import React, { useEffect, useState, useContext, useRef } from 'react';
import { debounce } from 'lodash';
import APIService from '@shared/services/api';
import List from '@shared/component/List';
import Notify from '@shared/notify';
import TextInput from '@shared/component/TextInput';
import { AuthContext } from '@shared/context/AuthContext';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import DropDown from '@shared/component/DropDown';
import CheckValidator from '@shared/checkValidator';
import { ActionValues, actionsPermissionValidator, checkUrlString } from '@utils/static/commonUtils';
import MultiSelect from '@shared/component/MultiSelect';
import Lists from '@shared/component/Lists';

function Location() {
    const [errors, setError] = useState<any>({
        pincode: {
            required: true,
            error: true,
            message: 'Please enter pincode',
            pattern: /^(\d{6})$/,
            maxLength: 6,
        },
        nickName: {
            required: true,
            error: true,
            pattern: /^[a-zA-Z-'. ]+$/,
            message: 'Please enter Location name',
            maxLength: 30,
        },
        state: {
            required: true,
            error: false,
            message: 'Please enter state',
            maxLength: 20,
            readOnly: true,
        },
        area: {
            required: true,
            error: true,
            message: 'Please enter area name',
            pattern: /^[a-zA-Z-'. ]+$/,
            maxLength: 30,
        },
        city: {
            required: true,
            error: true,
            message: 'Please select city',
            maxLength: 20,
        },
    });

    const listRef: any = useRef(null);
    const cityRef: any = useRef(null);
    const [showPincodeError, setshowPincodeError] = useState(false);
    const { setLoader } = useContext(AuthContext);
    const [locationData, setLocationData] = useState([]);
    const [isSubmit, setIsSubmit] = useState(false);
    const [newItem, setNewItem] = useState<any>({
        pincode: null,
        state: null,
        city: null,
        cityData: null,
        area: null,
        nickName: null,
    });
    const [editItemId, setEditItemId] = useState(null);
    const [edit, setEdit] = useState(false);
    const [recordCount, setRecordCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [city, setCity] = useState<any>([]);

    const [showHideModel, setShowHideModel] = useState(false);

    const [columns, setColumns] = useState({
        id: 'ID',
        pincode: 'Pincode',
        state: 'State',
        city: 'City',
        nickName: 'Location Name',
        area: 'Area',
        status: 'Status',
        ...(actionsPermissionValidator(location.pathname, ActionValues.Edit) ? { action: 'Action' } : null),
        // action: 'Action',
    });

    const getLocation = async (page?: any) => {
        try {
            if (!page) {
                page = currentPage;
            }
            setLoader(true);
            setCurrentPage(page);
            const data = await APIService.getAll(`location/?page=${page}&sort=createdAt`, true, false);
            setLocationData(data.data.data);
            setRecordCount(data?.data?.count || 0);
            setLoader(false);
            // setNewItem({ ['state']: null, ['city']: null, ['pincode']: null });
        } catch (err) {
            setLoader(false);
        }
    };

    const checkPincode = async (itemToEdit: any, isNew?: any) => {
        try {
            const code = itemToEdit.pincode;
            setLoader(true);

            const data = await APIService.getAll(`location/getPincode/${code}`, true, false);

            setLoader(false);

            if (data?.data?.Status == 'Error' || data?.data?.Status == '404') {
                Notify('error', data?.data?.[0]?.Message || 'Please enter valid pincode');

                handleReset();
                setCity([]);
                setshowPincodeError(true);
            } else {
                const dataRes = data?.data?.data || [];
                let cityData: any = null;

                const uniqueDistrictsArray: { city: string }[] = [
                    ...new Set(dataRes.map((post: any) => post.city)),
                ].map((city: string) => ({ District: city }));

                // const uniqueCities = Array.from(
                //     new Set(data.data.data.map((post: any) => ({ District: post.city }))),
                // );
                setCity(uniqueDistrictsArray);

                if (isNew) {
                    itemToEdit['city'] = null;
                    cityData = null;
                } else {
                    cityData = { label: itemToEdit?.city || null, value: itemToEdit?.id || 0 };
                }
                setNewItem({
                    ...itemToEdit,
                    ['state']: dataRes?.[0]?.state || '',
                    ['pincode']: code,
                    cityData: cityData,
                });
                setshowPincodeError(false);
                // handelModel(true);
            }
            setLoader(false);
        } catch (err) {
            setLoader(false);
        }
    };

    // search
    const searchItem = async (value: any, page: any) => {
        try {
            if (!page) {
                page = 1;
                listRef.current.resetPagination();
            }
            const data = await APIService.getAll(
                `location/search/get?page=${page}&order=desc&sort=createdAt&search=${value}`,
                true,
                false,
            );
            setLoader(false);

            setLocationData(data.data.data);
            setRecordCount(data.data.count);
        } catch (err) {
            setLoader(false);
        }
    };

    // update status
    const updateStatus = async (item: any, status: any, id: any, page: any, search: any) => {
        try {
            setLoader(true);
            const data = {
                status: status,
            };
            const updateddata = await APIService.update('location/updatelocationStatus', id, data, true, false);
            setLoader(false);
            if (updateddata.status === 200) {
                Notify('success', ' Location status updated successfully');
                // getLocation(page);
                searchItem(search.trim(), page);
            }
        } catch (err) {
            setLoader(false);
        }
    };
    const addItem = async () => {
        try {
            const isValid = await CheckValidator(errors, newItem);
            setIsSubmit(!isValid);

            if (isValid) {
                const data = {
                    state: newItem.state,
                    city: newItem.city,
                    pincode: newItem.pincode,
                    ...(newItem.area && { area: newItem.area }),
                    ...(newItem.nickName && { nickName: newItem.nickName }),
                };
                setLoader(true);
                const { status } = await APIService.post('location/', data, true, false);
                setLoader(false);
                if (status === 200) {
                    handelModel(false);
                    Notify('success', 'Location added successfully');
                    getLocation();
                    listRef.current.clearSearchBox();
                }
            }
        } catch (err) {
            setLoader(false);
        }
    };

    // edit
    const editItem = async () => {
        try {
            const isValid = await CheckValidator(errors, newItem);
            setIsSubmit(!isValid);
            // return
            if (isValid) {
                const data = {
                    state: newItem.state,
                    city: newItem.city,
                    pincode: newItem.pincode,
                    area: newItem.area,
                    nickName: newItem.nickName,
                };
                setLoader(true);
                const { status } = await APIService.update(`location`, editItemId, data, true, false);
                setLoader(false);
                if (status === 200) {
                    handelModel(false);
                    handleReset();
                    Notify('success', 'Location updated successfully');
                    getLocation(currentPage);
                    listRef.current.clearSearchBox(true);
                }
            }
        } catch (err) {
            setLoader(false);
        }
    };

    // handleEdit

    const handleEdit = (itemId: any) => {
        try {
            setLoader(true);
            const itemToEdit: any = locationData?.find((i: any) => i.id === itemId);
            setEditItemId(itemId);
            checkPincode(itemToEdit);
            // setNewItem({
            //     ...newItem,
            //     cityData: { label: itemToEdit?.city|| '', value: itemToEdit?.id || 0 },
            // });
            setEdit(true);
            handelModel(true);
            setLoader(false);
        } catch (error) {
            setLoader(false);
        }
    };

    const handleReset = () => {
        setNewItem({ ['state']: null, ['city']: null, ['pincode']: null });
    };

    // delete
    const getDeleteIds = async (ids: any) => {
        try {
            setLoader(true);
            const data = {
                ids: JSON.stringify(ids),
            };
            const updateddata = await APIService.post('location/delete/location', data, true, true);
            Notify('success', 'Location deleted successfully');
            getLocation();
            setLoader(false);
        } catch (error) {
            setLoader(false);
            getLocation();
        }
    };

    const getValue = (e: any) => {
        try {
            setshowPincodeError(false);
            if (e?.pincode?.trim()?.length > 0 && errors.pincode.pattern.test(e?.pincode?.trim())) {
                checkPincode({ ...newItem, pincode: e?.pincode }, true);
            } else if (e.pincode === null) {
                e = { pincode: null, state: '', city: '' };
                setCity([]);
                cityRef.current.clearDropdown();
            }
            // const data = { ...newItem, ...e };
            setNewItem(data => {
                return { ...data, ...e };
            });
        } catch (error) {
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        getLocation();
    }, []);

    const handelModel = (flag: boolean) => {
        try {
            if (!flag) {
                setCity([]);
                cityRef.current.clearDropdown();
                setEdit(false);
            }
            setShowHideModel(flag);
            setIsSubmit(false);
            handleReset();
        } catch (error) {}
    };

    return (
        <>
            <div className="container-fluid">
                <div className="main_body_cover">
                    <div className="container dash-container">
                        <div className="dash_bread_box">
                            <ul>
                                <li>Manage Locations</li>
                            </ul>
                        </div>
                        <div className="content_body_cover">
                            <Lists
                                ref={listRef}
                                headers={columns}
                                data={locationData}
                                searchItem={searchItem}
                                getDeleteIds={getDeleteIds}
                                updateStatus={updateStatus}
                                getById={handleEdit}
                                type="add+delete"
                                addUpdateText=""
                                handelModel={(e: boolean) => handelModel(e)}
                                recordCount={recordCount}
                                callPagination={getLocation}
                                helperText={'Search By Location Name ,Area, Pincode.State,City'}
                            />
                        </div>
                    </div>
                </div>

                {showHideModel && (
                    <Modal
                        scrollable={true}
                        show={true}
                        onHide={() => handelModel(false)}
                        backdrop="static"
                        keyboard={false}
                        size={'lg'}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title> {edit ? 'Update Location' : 'Add New Location'}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="material_form_cover">
                                <form
                                    onSubmit={e => {
                                        e.preventDefault();
                                    }}
                                >
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="form-floating">
                                                <TextInput
                                                    data={{
                                                        type: 'text',
                                                        placeholder: ' Location Name',
                                                        name: 'nickName',
                                                        id: 'floatingInput',
                                                    }}
                                                    controlName="nickName"
                                                    isSubmit={isSubmit}
                                                    value={newItem?.nickName}
                                                    setValue={(e: any) => getValue(e)}
                                                    inputProps={errors}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="form-floating">
                                                <TextInput
                                                    data={{
                                                        type: 'Number',
                                                        placeholder: 'Pincode',
                                                        name: 'pincode',
                                                        id: 'floatingInput',
                                                    }}
                                                    controlName="pincode"
                                                    isSubmit={isSubmit}
                                                    value={newItem?.pincode}
                                                    setValue={(e: any) => getValue(e)}
                                                    errorMsg={errors?.pincode.message}
                                                    inputProps={errors}
                                                />
                                                {showPincodeError && isSubmit && (
                                                    <div className="text-danger ft-12"> {'Invalid Pincode'}</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="form-floating">
                                                <TextInput
                                                    data={{
                                                        type: 'text',
                                                        placeholder: 'State',
                                                        name: 'state',
                                                        id: 'floatingInput',
                                                    }}
                                                    controlName="state"
                                                    isSubmit={isSubmit}
                                                    value={newItem?.state}
                                                    setValue={(e: any) => getValue(e)}
                                                    errorMsg={errors?.state.message}
                                                    inputProps={errors}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <MultiSelect
                                                ref={cityRef}
                                                isSingle={true}
                                                options={city}
                                                placeholder={'Select City*'}
                                                getMultiSelectValue={(e: any) => {
                                                    // getValue(e);
                                                    if (e?.value) {
                                                        getValue({ city: e.value });
                                                        errors['city']['error'] = false;
                                                        setError(errors);
                                                    }
                                                }}
                                                displayName="District"
                                                displayValue={'District'}
                                                isClearable={false}
                                                setSelectedValues={newItem?.cityData || null}
                                            />

                                            {errors?.city?.required && errors?.city?.error && isSubmit && (
                                                <div className="text-danger ft-12"> {errors?.city.message}</div>
                                            )}
                                        </div>
                                    </div>
                                    <br />
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="form-floating">
                                                <TextInput
                                                    data={{
                                                        type: 'text',
                                                        placeholder: 'Enter Area Name',
                                                        name: 'area',
                                                        id: 'floatingInput',
                                                    }}
                                                    controlName="area"
                                                    isSubmit={isSubmit}
                                                    value={newItem?.area}
                                                    setValue={(e: any) => getValue(e)}
                                                    errorMsg={errors?.pincode.message}
                                                    inputProps={errors}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* </div> */}
                                </form>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="secondary"
                                className="btn dark_btn custom_btn"
                                onClick={edit ? editItem : addItem}
                            >
                                {edit ? 'Update' : 'Add'}
                            </Button>
                            <Button
                                variant="default"
                                className="btn custom_btn border_btn with_icon"
                                onClick={() => handelModel(false)}
                            >
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
            </div>
        </>
    );
}

export default Location;
